// src/components/TermsAndConditions.js
import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "./TermsAndConditions.css"; // (optional, if you want custom styling here)
import { Helmet } from "react-helmet";


<Helmet>
  <title>Terms & Conditions | Legal Info | Kora Insurance</title>
  <meta name="description" content="Read the legal terms and conditions governing the use of the YourBrand insurance platform." />
  <meta name="keywords" content="Insurance Ghana, Family Insurance, Affordable Cover, Kora Insurance" />
  <meta name="robots" content="noindex, nofollow" />
  <link ref="canonical" href="https://korame.com.gh"/>
  {/* Open Graph tags */}
  <meta property="og:title" content="Best Online Insurance Platform" />
  <meta property="og:description" content="Compare and buy insurance plans with ease." />
  <meta property="og:url" content="https://korame.com.gh/" />
  <meta property="og:type" content="website" />
</Helmet>

function TermsAndConditions() {
  return (
    <div className="terms-page">
      <Header />

      <div className="terms-content">
        <div className="hero-section">
          <h1 className="page-title">Terms & Conditions</h1>
          <p className="page-subtitle">
            Please read these terms carefully before using our services.
          </p>
        </div>

        <section className="section-block">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing or using the Kora Insurance website, you agree to
            be bound by all the terms and conditions outlined here. If you do
            not accept these terms, please discontinue use of our services.
          </p>
        </section>

        <section className="section-block">
          <h2>2. Payment & Premiums</h2>
          <p>
            We partner with trusted payment providers to process premium
            payments. All fees and charges must be paid in full by the due
            date. Failure to remit payment by the specified deadline may result
            in cancellation or suspension of coverage.
          </p>
        </section>

        <section className="section-block">
          <h2>3. Refund Policy</h2>
          <p>
            Premiums paid are generally non-refundable. Under certain limited
            circumstances, you may be eligible for a partial refund, subject to
            review. For more details, please contact our support team.
          </p>
        </section>

        <section className="section-block">
          <h2>4. Modifications to Terms</h2>
          <p>
            We reserve the right to modify or replace these terms at any time,
            at our sole discretion. Any changes will take effect immediately
            upon posting.
          </p>
        </section>

        <section className="section-block">
          <h2>5. Contact Information</h2>
          <p>
            If you have any questions about these Terms & Conditions, please
            reach out to us at:
            <br />
            <strong>Email:</strong> hello@summerhealth.io
            <br />
            <strong>Phone:</strong> +233 50 049 0065
          </p>
        </section>
      </div>

      <Footer />
    </div>
  );
}

export default TermsAndConditions;
